import ObJectFit from "objectFitPolyfill";
import Slider from "./components/Slider";
import Accordion from "./components/Accordion";
import HiddenSection from "./components/HiddenSection";
import Content from "./components/Content";
import Form from "./components/Form";
import Search from "./components/Search";
import ContentHub from "./components/ContentHub";
import LazyLoad from "./components/LazyLoad";
import Timeline from "./components/Timeline";
import Lightbox from "./components/Lightbox";
import Filter from "./components/Filters";
import Sidebar from "./components/sidebar";

const Core = {
  sliders: new Slider(),
  HiddenSection: new HiddenSection(),
  Content: new Content(),
  Form: new Form(),
  Search: new Search(),
  lazyload: new LazyLoad(),
  ContentHub: new ContentHub(),
  Timeline: new Timeline(),
  Lightbox: new Lightbox(),
  Filter: new Filter(),
  Sidebar: new Sidebar(),
  Accordion: new Accordion(".js-accordion-btn"),
};
